// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as VGSVault$OrcaPaymentPage from "./VGSVault.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CardCVCElement$OrcaPaymentPage from "../CardCVCElement.bs.js";
import * as CommonCardProps$OrcaPaymentPage from "../Hooks/CommonCardProps.bs.js";
import * as RawCardCollector$OrcaPaymentPage from "./RawCardCollector.bs.js";
import * as HyperswitchVaultCardCollector$OrcaPaymentPage from "./HyperswitchVaultCardCollector.bs.js";

function CardsSDK(props) {
  let __cvcOnly = props.cvcOnly;
  let __cvcOnly_value = __cvcOnly !== undefined ? __cvcOnly : false;
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  let cardCollectionMode = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardCollectionMode);
  let isBancontact = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isBancontactCardFlow);
  let cardFlowType = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardFlowType);
  let savedCardBrand = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.savedCardBrand);
  let setShowPaymentMethodsScreen = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  React.useEffect(() => {
    if (!__cvcOnly_value) {
      setShowPaymentMethodsScreen(param => true);
    }
  }, [__cvcOnly_value]);
  let match = CommonCardProps$OrcaPaymentPage.useCardForm(loggerState, cardFlowType, cardCollectionMode !== "RawEmit", cardCollectionMode !== "RawEmit", cardCollectionMode === "RawEmit" && !__cvcOnly_value, __cvcOnly_value ? savedCardBrand : "");
  let cvcProps = match.cvcProps;
  let expiryProps = match.expiryProps;
  let cardProps = match.cardProps;
  if (cardCollectionMode === "Tokenise") {
    if (typeof vaultCredentials !== "object") {
      return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: !__cvcOnly_value,
        children: JsxRuntime.jsx(HyperswitchVaultCardCollector$OrcaPaymentPage.make, {
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        })
      });
    } else if (vaultCredentials.TAG === "HyperswitchVault") {
      if (__cvcOnly_value) {
        return JsxRuntime.jsx(CardCVCElement$OrcaPaymentPage.make, {
          cvcProps: cvcProps,
          paymentType: "CardCVCElement",
          isSavedCardCvcFlow: true,
          isVaultCvcFlow: true,
          savedCardBrand: savedCardBrand
        });
      } else {
        return JsxRuntime.jsx(HyperswitchVaultCardCollector$OrcaPaymentPage.make, {
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        });
      }
    } else {
      return JsxRuntime.jsx(VGSVault$OrcaPaymentPage.make, {
        cvcOnly: __cvcOnly_value
      });
    }
  } else if (__cvcOnly_value) {
    return JsxRuntime.jsx(CardCVCElement$OrcaPaymentPage.make, {
      cvcProps: cvcProps,
      paymentType: "CardCVCElement",
      isSavedCardCvcFlow: true,
      savedCardBrand: savedCardBrand
    });
  } else {
    return JsxRuntime.jsx(RawCardCollector$OrcaPaymentPage.make, {
      cardProps: cardProps,
      expiryProps: expiryProps,
      cvcProps: cvcProps,
      isBancontact: isBancontact
    });
  }
}

let make = CardsSDK;

export {
  make,
}
/* jotai Not a pure module */
